import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function RegisterModal({ show, handleClose, license, onRegisterSuccess }) {
  const [formData, setFormData] = useState({
    registrationNumber: "",
    validityPeriod: "",
    registrationDate: "",
    expDate: "",
    amount: "",
    billNo: "",
  });

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (license) {
      setFormData({
        registrationNumber: license.reg_no || "",
        validityPeriod: "",
        registrationDate: "",
        expDate: "",
        amount: "",
        billNo: "",
      });
    }
  }, [license]);

  useEffect(() => {
    if (formData.registrationDate && formData.validityPeriod) {
      const startDate = new Date(formData.registrationDate);
      const validityYears = parseInt(formData.validityPeriod, 10);

      if (!isNaN(validityYears)) {
        startDate.setFullYear(startDate.getFullYear() + validityYears);

        const year = startDate.getFullYear();
        const month = String(startDate.getMonth() + 1).padStart(2, "0");
        const day = String(startDate.getDate()).padStart(2, "0");
        const newExpDate = `${year}-${month}-${day}`;

        setFormData((prevData) => ({ ...prevData, expDate: newExpDate }));
      }
    }
  }, [formData.registrationDate, formData.validityPeriod]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!license || !license.id) {
      toast.error("License ID is missing. Cannot register.");
      return;
    }

    // Create a plain JavaScript object for the JSON payload
    const apiPayload = {
      id: license.id,
      trade_name: license.trade_name,
      trade_owner: license.trade_owner,
      validity_peroid: `${formData.validityPeriod} Year`, // Note the key name and format
      amount: formData.amount,
      reg_date: formData.registrationDate,
      expire_date: formData.expDate,
      reg_no: formData.registrationNumber || "", // Send empty string if optional field is empty
      bill_no: formData.billNo || "", // Send empty string if optional field is empty
    };

    try {
      const response = await axios.post(
        `${API_URL}reg-trade-license.php`,
        apiPayload, // Send the JSON object directly
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type to JSON
          },
        }
      );

      if (response.data.success) {
        toast.success(
          response.data.message || "License Registered Successfully!"
        );
        if (onRegisterSuccess) {
          onRegisterSuccess();
        }
        handleClose();
      } else {
        toast.error(response.data.message || "Failed to register license.");
      }
    } catch (error) {
      toast.error("An error occurred while registering the license.");
    }
  };

  if (!license) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Register Trade License</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Trade Name</Form.Label>
            <Form.Control
              type="text"
              value={license.trade_name}
              readOnly
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Owner Name</Form.Label>
            <Form.Control
              type="text"
              value={license.trade_owner}
              readOnly
              disabled
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Registration Number (Optional)</Form.Label>
            <Form.Control
              type="text"
              name="registrationNumber"
              value={formData.registrationNumber}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Bill Number (Optional)</Form.Label>
            <Form.Control
              type="text"
              name="billNo"
              value={formData.billNo}
              onChange={handleChange}
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  <strong>Validity Period</strong>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="validityPeriod"
                  value={formData.validityPeriod}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Period...</option>
                  <option value="1">1 Year</option>
                  <option value="2">2 Years</option>
                  <option value="3">3 Years</option>
                  <option value="4">4 Years</option>
                  <option value="5">5 Years</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={formData.amount}
                  placeholder="₹"
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Registration Date</Form.Label>
                <Form.Control
                  type="date"
                  name="registrationDate"
                  value={formData.registrationDate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Expiration Date</Form.Label>
                <Form.Control
                  type="date"
                  name="expDate"
                  value={formData.expDate}
                  onChange={handleChange}
                  required
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button variant="success" type="submit">
              Register
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default RegisterModal;
